import React, { forwardRef } from "react";

/**
 * ─── Textarea ──────────────────────────────────────────────────────────────
 * Multi-line text input (PDR v2.1 §8).
 *
 * Props:
 *   error   boolean
 *   testId
 * All native textarea props pass through.
 */
const Textarea = forwardRef(function Textarea(
  { error = false, className = "", testId, ...rest },
  ref,
) {
  const cn = ["ds-textarea", error && "ds-textarea--error", className].filter(Boolean).join(" ");
  return (
    <textarea ref={ref} className={cn} data-testid={testId} aria-invalid={error || undefined} {...rest} />
  );
});

export default Textarea;
